class Navigation extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector(".hd-Header_MenuButton");
    this.panel = this.querySelector(".hd-MobileMenu");
    if (!this.button || !this.panel) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.button.addEventListener(
      "click",
      () => this.toggle(this.panel.hidden),
      options,
    );
    this.panel.addEventListener(
      "click",
      (event) => {
        if (event.target.closest("a[href]")) this.toggle(false, false);
      },
      options,
    );
    document.addEventListener(
      "keydown",
      (event) => {
        if (this.panel.hidden) return;
        if (event.key === "Escape") {
          event.preventDefault();
          this.toggle(false);
        }
        if (event.key !== "Tab") return;
        const links = [
          ...this.panel.querySelectorAll("a[href], button, summary"),
        ];
        const focusable = [this.button, ...links];
        const first = focusable[0],
          last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      },
      options,
    );
    this.desktop = matchMedia("(min-width: 768px)");
    this.desktop.addEventListener(
      "change",
      (event) => {
        if (event.matches) this.toggle(false, false);
      },
      options,
    );
  }

  toggle(open, restoreFocus = true) {
    if (!open && this.panel.hidden) return;
    this.button.setAttribute("aria-expanded", String(open));
    this.button.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    this.panel.hidden = !open;
    document.documentElement.classList.toggle("hd-MobileMenu-open", open);
    if (open) {
      this.background = [
        ...document.querySelectorAll("body > main, body > footer"),
      ].map((element) => ({ element, inert: element.inert }));
      this.background.forEach(({ element }) => {
        element.inert = true;
      });
      this.panel.querySelector("a[href]")?.focus({ preventScroll: true });
    } else {
      this.background?.forEach(({ element, inert }) => {
        element.inert = inert;
      });
      if (restoreFocus) this.button.focus({ preventScroll: true });
    }
  }

  disconnectedCallback() {
    if (this.panel && !this.panel.hidden) this.toggle(false, false);
    this.events?.abort();
  }
}
if (!customElements.get("menu-nav"))
  customElements.define("menu-nav", Navigation);
